import { AccessLinkReadMetadata } from '@llx/common';

import { AccessLinkTypes } from '@/@generated/codegen/API';
import { config } from '@/environment';
import { ROUTES } from '@/routes/Routes';

export const getAccessLinkUrl = (code: string) => {
  return `${window.location.origin}${ROUTES.ACCESS_LINK}/${code}`;
};

type Args = {
  type: AccessLinkTypes;
  objId: string;
  metadata: AccessLinkReadMetadata | null | undefined;
};

export const getAccessLinkTargetUrl = (args: Args): string | null => {
  const { type, objId } = args;
  switch (type) {
    case AccessLinkTypes.CasePreview:
      return `${window.location.origin}${ROUTES.PREVIEW_CASE}/${objId}`;
    case AccessLinkTypes.MeetingReadAccess:
      return `${window.location.origin}${ROUTES.LIVE_MEETING}/${objId}`;
    case AccessLinkTypes.MasterclassReadAccess:
      return `${config.MASTERCLASS_URL}/masterclass/${objId}/cases`;
    case AccessLinkTypes.ClientRegistration:
      return null;
    default: {
      const _exhaustiveCheck: never = type;
      throw new Error(`Unhandled access link type in getAccessLinkTargetUrl`);
    }
  }
};
